import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import DataGrid, { Column, Editing, Paging, Lookup, Export, Selection } from 'devextreme-react/data-grid';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import { API } from '../../API/API';
import { UserContext } from '../../context/UserContext';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { Space, message } from 'antd';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ButtonSecondary from '../../components/ButtonSecondary/ButtonSecondary';
import * as xlsx from "xlsx";
import moment from 'moment';
import { Autocomplete } from 'devextreme-react';

const ExcelImportEmp = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const gridRef = useRef();
    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [dDepartment, setDDepartment] = useState([]);
    const [dPosition, setDPosition] = useState([]);
    const [dInsureType, setDInsureType] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const [loadingUpload, setLoadingUpload] = useState(false);
    const [dKeyUpload, setDKeyUpload] = useState(1);

    const [selectedKey, setSelectedKey] = useState([]);

    const getData = async () => {

        let tDDepartment = [];
        let tDPosition = [];
        let tDInsureType = [];

        try {
            setLoading(true);
            await API.get('/api/humanresource/organization/get_department_dropdown?companyid=' + userInfo.companyid).then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDDepartment = response?.data?.retdata;
                }
            });
            await API.get('/api/humanresource/organization/get_position_dropdown?companyid=' + userInfo.companyid).then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDPosition = response?.data?.retdata;
                }
            });
            await API.get('/api/humanresource/organization/get_insure_type_dropdown').then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tDInsureType = response?.data?.retdata;
                }
            });

        } finally {
            setLoading(false);
        }

        tDPosition?.map(r => r.key = parseInt(r?.key));
        tDInsureType?.map(r => r.key = parseInt(r?.key));

        setDInsureType(tDInsureType);
        setDDepartment(tDDepartment);
        setDPosition(tDPosition);

    }

    useEffect(() => {
        getData();
    }, []);

    const getDataFromProps = () => {
        let tData = [];
        if (location?.state?.length > 0) {
            location.state.map((r, index) => {
                let tGender = null;
                if (r?.general?.gender == "MALE") {
                    tGender = "M";
                } else if (r?.general?.gender == "FEMALE") {
                    tGender = "F";
                }

                let tBirthDate = null;
                if (r?.general?.birthDate) {
                    tBirthDate = r?.general?.birthDate?.replaceAll("-", ".");
                }

                tData.push({
                    "id": index,
                    "regno": r?.general?.regnum ?? null,
                    "lastname": r?.general?.lastname ?? null,
                    "firstname": r?.general?.firstname ?? null,
                    "depid": null,
                    "depname": "",
                    "positionid": null,
                    "positionname": "",
                    "insuretypeid": 1,
                    "begindate": "",
                    "basewage": "",
                    "gender": tGender,
                    "birthdate": tBirthDate,
                    "mobilephone": r?.general?.contactinfo?.phone ?? null,
                    "email": r?.general?.contactinfo?.email ?? null
                });
            });
        }
        setData(tData);
    }

    useEffect(() => {
        getDataFromProps();
    }, [location.state])

    const onSave = async () => {
        let vSuccess = false;

        let tData = [...data];
        let tGrid = gridRef?.current?.instance?.getController('editing')?._changes;
        if (tGrid?.length > 0) {
            tGrid?.map(r => {
                if (r?.type == "update" && r.data) {
                    let tIndex = tData?.map(ri => ri.id).indexOf(r.key);
                    if (tIndex >= 0) {
                        tData[tIndex] = {
                            ...tData[tIndex],
                            ...r.data
                        };
                    }
                }
            });
        }

        let tCheckData = tData?.filter(r => (!r.regno ||
            !r.lastname ||
            !r.firstname ||
            !r.depname ||
            !r.positionname ||
            !r.insuretypeid ||
            !r.begindate ||
            !r.basewage));

        if (tData?.length > 0 && tCheckData?.length == 0) {
            try {
                setLoadingSave(true);
                await API.post("/api/humanresource/Organization/saveEmpFromExcel", tData).then(response => {
                    if (response?.status == 200 && response?.data?.rettype == 0) {
                        message.success("Амжилттай");
                        vSuccess = true;
                    }
                });
            } finally {
                setLoadingSave(false);
            }
        } else {
            message.warning("Ажилтны мэдээлэл дутуу байна!.");
        }

        if (vSuccess) {
            setData([]);

            let tCount = 0;
            await API.get('/api/humanresource/organization/getFeedbackCount?pageurl=/excelimportemp').then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    tCount = response?.data?.retdata;
                }
            });
            
            if (tCount == 0) {
                if (props?.setFeedbackPage) {
                    props.setFeedbackPage("/excelimportemp");
                }

                if (props?.setFeedbackUnixId) {
                    props.setFeedbackUnixId(moment().unix());
                }
            }
            navigate("/hrsuite");
        }
    }

    const onChangeDep = (newData, value, currentRowData) => {

        let tDepId = -1;
        if (value) {
            let tDep = dDepartment?.filter(r => r.name?.toLowerCase() == value?.toLowerCase());
            if (tDep?.length > 0) {
                tDepId = tDep[0].key;
            }
        }

        newData.depid = tDepId;
        newData.depname = value;
        newData.positionid = null;
    }

    const onChangePos = (newData, value, currentRowData) => {

        let tPosId = -1;
        if (value) {
            let tPos = dPosition?.filter(r => r.text?.toLowerCase() == value?.toLowerCase());
            if (tPos?.length > 0) {
                tPosId = tPos[0].key;
            }
        }

        newData.positionname = value;
        newData.positionid = tPosId;

    }

    const onExcelExport = () => {
        if (gridRef?.current) {
            gridRef?.current?.instance?.exportToExcel();
        }
    }

    const onExcelUpload = async (pData) => {
        try {
            setLoadingUpload(true);
            let tData = [];
            if (pData?.length > 0) {
                pData?.map((r, index) => {

                    let vBegindate = null;
                    if (r["Эхэлсэн огноо"] && moment(r["Эхэлсэн огноо"]).isValid()) {
                        vBegindate = moment(r["Эхэлсэн огноо"]).format("YYYY.MM.DD");
                    }

                    let vBasewage = null;
                    if (r["Үндсэн цалин"] && !isNaN(r["Үндсэн цалин"])) {
                        vBasewage = parseFloat(r["Үндсэн цалин"]);
                    }

                    let tDepid = -1;
                    if (r["Байгууллага нэгж"]) {
                        let tIndex = dDepartment?.map(r => r.name?.toString().toLowerCase()).indexOf(r["Байгууллага нэгж"]?.toString().toLowerCase());
                        if (tIndex >= 0) {
                            tDepid = dDepartment[tIndex].key;
                        }
                    }

                    let tPositionid = -1;
                    if (r["Ажлын байр"]) {
                        let tDPosition = dPosition?.filter(r => r.depid == tDepid);
                        let tIndex = tDPosition?.map(r => r.text?.toString().toLowerCase()).indexOf(r["Ажлын байр"]?.toString().toLowerCase());
                        if (tIndex >= 0) {
                            tPositionid = tDPosition[tIndex].key;
                        }
                    }

                    let tInsuretypeid = 1;
                    if (r["Даатгуулагчийн төрөл"]) {
                        let tIndex = dInsureType?.map(r => r.text?.toString().toLowerCase().split(" - ")[1]).indexOf(r["Даатгуулагчийн төрөл"]?.toString().toLowerCase());
                        if (tIndex >= 0) {
                            tInsuretypeid = dInsureType[tIndex].key;
                        }
                    }

                    tData.push({
                        "id": index,
                        "regno": r["Регистрийн дугаар"] ?? null,
                        "lastname": r["Овог"] ?? null,
                        "firstname": r["Нэр"] ?? null,
                        "depid": tDepid,
                        "depname": r["Байгууллага нэгж"] ?? "",
                        "positionid": tPositionid,
                        "positionname": r["Ажлын байр"] ?? "",
                        "insuretypeid": tInsuretypeid,
                        "begindate": vBegindate,
                        "basewage": vBasewage
                    });
                });
            }

            setData(tData);
        } finally {
            setLoadingUpload(false);
            setDKeyUpload(r => r = r + 1);
        }
    }

    const readUploadFile = async (e) => {
        e.preventDefault();

        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const dataExcel = e.target.result;
                const workbook = xlsx.read(dataExcel, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                var range = xlsx.utils.decode_range(worksheet['!ref']);
                range.s.r = 1;

                const jsonData = xlsx.utils.sheet_to_json(worksheet, { range: range });

                onExcelUpload(jsonData);

            };
            reader.readAsArrayBuffer(e.target.files[0]);
        }
    }

    const onDelete = () => {
        if (selectedKey?.length > 0) {
            let tData = [...data];

            tData = tData.filter(r => !selectedKey.includes(r.id));

            setData(tData);
        }
    }

    if (loading) {
        return (
            <LoadSpin space />
        );
    }

    return (
        <div className='hideGridHeader' style={{ padding: 16 }}>
            <div style={{ marginBottom: 16, width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 700, fontSize: 16 }}>Ажилтан {searchParams.get("pagetype") == "worki" ? "Worki" : "Excel"}-ээс нэмэх</div>
                <Space size={16}>
                    {selectedKey?.length > 0 ? <ButtonSecondary text={"Устгах (" + selectedKey?.length + ")"} onClick={onDelete} /> : null}
                    {searchParams.get("pagetype") == "worki" ? null : (
                        <Fragment>
                            <ButtonSecondary onClick={onExcelExport} text="1. Excel загвар татах" />
                            {loadingUpload ? <LoadSpin /> : (
                                <div key={dKeyUpload} className='fileUpload'>
                                    <label className='custom-file-upload'>
                                        <input
                                            type="file"
                                            name="upload"
                                            id="upload"
                                            onChange={readUploadFile}
                                        />
                                        <div style={{ height: 30, background: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0px 16px', border: '1px solid rgb(198, 198, 198)' }}>
                                            <div style={{ fontWeight: 600, fontSize: 14 }}>2. Excel-ээс оруулах</div>
                                        </div>
                                    </label>
                                </div>
                            )}
                        </Fragment>
                    )}
                    {loadingSave ? <LoadSpin /> : <ButtonDefault disabled={data?.length == 0} onClick={onSave} text={searchParams.get("pagetype") == "worki" ? "Хадгалах" : "3. Хадгалах"} />}
                </Space>
            </div>
            <DataGrid
                ref={gridRef}
                dataSource={data}
                keyExpr="id"
                showBorders={true}
                selectedRowKeys={selectedKey}
                onSelectionChanged={(pValue) => {
                    setSelectedKey(pValue?.selectedRowKeys?.length > 0 ? pValue?.selectedRowKeys : []);
                }}
            >
                <Selection mode="multiple" />
                <Paging enabled={false} />
                <Editing
                    mode="batch"
                    allowUpdating={true}
                    startEditAction="click" />
                <Export enabled={true} />
                <Column caption="Ажилтан">
                    <Column dataField="regno" caption="Регистрийн дугаар" />
                    <Column dataField="lastname" caption="Овог" />
                    <Column dataField="firstname" caption="Нэр" />
                </Column>
                <Column caption="Одоогийн ажил эрхлэлт">
                    <Column
                        dataField="depname"
                        caption="Байгууллага нэгж"
                        setCellValue={onChangeDep}
                        editCellRender={(cellInfo) => {
                            return (
                                <Autocomplete
                                    dataSource={dDepartment?.map(r => r.name)}
                                    defaultValue={cellInfo?.value}
                                    onValueChanged={(pValue) => { cellInfo.setValue(pValue?.value); }}
                                />
                            );
                        }}
                    />
                    <Column
                        dataField="positionname"
                        caption="Ажлын байр"
                        setCellValue={onChangePos}
                        editCellRender={(cellInfo) => {
                            return (
                                <Autocomplete
                                    dataSource={dPosition?.filter(r => r.depid == cellInfo?.data?.depid)?.map(r => r.text)}
                                    defaultValue={cellInfo?.value}
                                    onValueChanged={(pValue) => { cellInfo.setValue(pValue?.value); }}
                                />
                            );
                        }}
                    />
                    <Column dataField="insuretypeid" caption="Даатгуулагчийн төрөл" >
                        <Lookup dataSource={dInsureType} valueExpr="key" displayExpr="text" />
                    </Column>
                    <Column dataField="begindate" caption="Эхэлсэн огноо" dataType="date" />
                    <Column dataField="basewage" caption="Үндсэн цалин" dataType="number" format="fixedPoint" />
                </Column>
            </DataGrid>
        </div >
    );
}

export default ExcelImportEmp;